import { useState } from 'react'

import { useAsyncCallback } from '../../../../hooks'
import { transformSelectAreaCoordinatesToPercentCoordinates } from '../../../PdfViewer'
import { useDocFlowContext } from '../useDocFlowContext'

export function useDocFlowSelectAreaInfo({
  isInitSelectArea,
  pdfPageCoordinates,
  selectedBox,
  setSelectedBox,
  onHideSelectedArea,
}) {
  const { documentId, mappingPhaseFileActive } = useDocFlowContext()

  const [pdfSelectAreaInfoValue, setPdfSelectAreaInfoValue] = useState(null)
  const [isPdfSelectAreaInfoValueLoading, setPdfSelectAreaInfoValueLoading] =
    useState(false)
  const [isOpenValueInfo, setOpenValueInfo] = useState(false)

  function handleResetCurrentSelectedArea() {
    // eslint-disable-next-line react-hooks/immutability -- isInitSelectArea is a parent-owned ref; resetting .current here is intentional
    isInitSelectArea.current = false

    onHideSelectedArea()
    setSelectedBox(null)
    setOpenValueInfo(false)
    setPdfSelectAreaInfoValue(null)
  }

  const handleGetSelectedAreaInfo = useAsyncCallback(
    ({ apiFunction, data, getSelectedAreaData }) => {
      setPdfSelectAreaInfoValueLoading(true)
      setOpenValueInfo(true)

      return apiFunction({
        data: {
          ...data,
          area: transformSelectAreaCoordinatesToPercentCoordinates(
            selectedBox,
            pdfPageCoordinates
          ),
        },
        documentId,
        itemId: mappingPhaseFileActive,
      })
        .then(({ data }) => {
          setPdfSelectAreaInfoValue(getSelectedAreaData(data))

          setPdfSelectAreaInfoValueLoading(false)

          return data
        })
        .catch(() => {
          setPdfSelectAreaInfoValueLoading(false)
          setOpenValueInfo(false)

          throw Error
        })
    },
    [documentId, mappingPhaseFileActive, selectedBox, pdfPageCoordinates]
  )

  return {
    handleGetSelectedAreaInfo,
    handleResetCurrentSelectedArea,
    isOpenValueInfo,
    isPdfSelectAreaInfoValueLoading,
    pdfSelectAreaInfoValue,
    setOpenValueInfo,
    setPdfSelectAreaInfoValue,
  }
}
